/* eslint-disable no-console */
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey("09297533d2cf01f1a267060cfe4a6702Tz0xMjk3NTYsRT0xODEyOTc0NDAwMDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=");

import { dispatchOnWebComponentLoadedEvent } from "@src/utils/events";
import { isValidAttributeConfig } from "@src/utils/typeGuard.utils";

import { render } from "./render";

let shadowRoot: ShadowRoot | null = null;

const attributes = ["config"];

class KtmSparePartsFinder extends HTMLElement {
    protected static get observedAttributes(): string[] {
        return attributes;
    }

    /** gets called when an attribute changes **/
    protected attributeChangedCallback(name: string, oldValue: unknown, newValue: unknown): void {
        if (oldValue !== newValue) {
            this.renderApp();
        }
    }

    /** gets called when the element is added to the DOM **/
    protected connectedCallback(): void {
        this.renderApp();
        dispatchOnWebComponentLoadedEvent();
    }

    private checkRequiredAttributes(): boolean {
        const errorMessages: string[] = [];

        for (const attribute of attributes) {
            if (!this.hasAttribute(attribute)) {
                console.warn(`pmag-spare-parts-finder missing '${attribute}' attribute`);
                errorMessages.push(`missing '${attribute}' attribute`);
            }
        }

        return errorMessages.length === 0;
    }

    protected renderApp(): void {
        if (!this.checkRequiredAttributes()) return;

        shadowRoot = this.shadowRoot;
        if (!shadowRoot) {
            shadowRoot = this.attachShadow({ mode: "open" });
            Object.defineProperty(this, "ownerDocument", { value: this.shadowRoot });
        }

        // create a root element for the shadow dom, which acts as a container for the app
        // MUI elements needs to set this as their container, to be able to render modals, tooltips, etc.
        const shadowRootElement = document.createElement("div");
        shadowRoot.appendChild(shadowRootElement);

        // handle attributes
        const configString = this.getAttribute("config") as unknown as string;
        const config = isValidAttributeConfig(configString);

        if (config) {
            void render(shadowRoot, shadowRootElement, config);
        } else {
            console.warn(`pmag-spare-parts-finder config attribute failed to parse`);
        }
    }
}
if (!window.customElements.get("pmag-spare-parts-finder")) {
    window.customElements.define("pmag-spare-parts-finder", KtmSparePartsFinder);
}
